import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import {
  CALL_INSURANCE_MODAL,
  COPAY_COINSURANCE_DETAILS_MODAL,
  INSURANCE_TUTORIAL_ENTRY_POINT_MODAL,
  INSURANCE_TUTORIAL_MODAL,
} from '../../../../../../constants/modalIds';

import TutorialModal from '../../../../../Account/Profile/Insurance/Tutorial/Modal';
import EntryPointModal from '../EntryPoint/Modal';
import { safeGet } from '../../../../../../core/util/object';
import useSelectInsuranceProfile from '../../../../hooks/useSelectInsuranceProfile';
import InsuranceHelpModal from '../../../../../Account/Profile/Insurance/components/InsuranceHelpModal';
import CopayCoinsuranceDetailsModal from '../CopayCoinsuranceDetailsModal';
import useModal from '../../../../../../hooks/useModal';

type Props = {
  userProfileId: string;
};

const ModalController = (props: Props) => {
  const { userProfileId } = props;
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);
  const runtime = useSelector((state: any) => state.runtime);
  const modal = runtime.modal || {};

  const insuranceHelpModalValue = safeGet(modal, false)(CALL_INSURANCE_MODAL);

  const { closeModal } = useModal();
  return (
    <>
      <TutorialModal
        closeModal={closeModal}
        insuranceProfile={insuranceProfile}
        open={!!modal[INSURANCE_TUTORIAL_MODAL]}
        userProfileId={userProfileId}
      />

      <InsuranceHelpModal
        insuranceProfile={insuranceProfile}
        modalValue={insuranceHelpModalValue}
        open={!!modal[CALL_INSURANCE_MODAL]}
      />

      <CopayCoinsuranceDetailsModal
        open={!!modal[COPAY_COINSURANCE_DETAILS_MODAL]}
        providerType={modal[COPAY_COINSURANCE_DETAILS_MODAL]}
        userProfileId={userProfileId}
      />

      <EntryPointModal
        open={!!modal[INSURANCE_TUTORIAL_ENTRY_POINT_MODAL]}
        userProfileId={userProfileId}
      />
    </>
  );
};

export default ModalController;
